<script setup>
import useCheckTable from "./hooks/useCheckTable";
import Adjust from "./adjust.vue";
import { onMounted, ref } from "vue";
import useStashList from "@/views/hooks/useStashList";
import { queryStatus } from "@/api/check";
import useUserList from "@/views/hooks/useUserList";

const { stashList } = useStashList();

const { userList } = useUserList();

const statusList = ref([]);

const {
  searchRef,
  editRef,
  searchData,
  tableLoading,
  tableData,
  columns,
  pages,
  dateRangeSelector,
  handleAdjust,
  getList,
  handleReset,
  handleClickDel,
  handleExport,
  handleSelectionChange,
  checkDateChange,
  createDateChange,
  handleCheckDone,
} = useCheckTable();

const getStatusList = () => {
  queryStatus().then((res) => {
    statusList.value = res.data || [];
  });
};

onMounted(() => {
  getList();
  getStatusList();
});
</script>

<template>
  <zh-table-page v-bind="{ title: '盘点调账' }">
    <template #header-btn
      ><el-button type="primary" icon="Plus" @click="handleAdjust(null, 'add')"
        >新增</el-button
      ></template
    >
    <template #search>
      <el-form :model="searchData" ref="searchRef" label-width="90px">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-form-item label="调整单号：" prop="number">
              <el-input v-model="searchData.number" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="创建人" prop="createByText">
              <el-input v-model="searchData.createByText" placeholder="请输入" />
              <!-- <el-select
                v-model="searchData.warehouseId"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in stashList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :xl="6" :sm="8">
            <el-form-item label="创建时间：">
              <el-date-picker
                v-model="dateRangeSelector.createDate"
                type="daterange"
                placeholder="请选择"
                style="width: 100%"
                @change="createDateChange()"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template #table>
      <!-- <el-button icon="Delete" @click="handleClickDel(null, true)"
        >批量删除</el-button
      > -->
      <el-button icon="Download" @click="handleExport()">导出</el-button>
      <el-button type="primary" icon="Search" @click="getList()"
        >查询</el-button
      >
      <el-button icon="Refresh" @click="handleReset()">重置</el-button>
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{
          'text-align': 'center',
        }"
        style="width: 100%; margin-top: 10px"
        max-height="650"
        v-loading="tableLoading"
        :data="tableData"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="55" fixed /> -->
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :min-width="120"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <el-tag
                v-if="item.prop == 'status'"
                :type="row[item.prop]?.value == '1' ? '' : 'success'"
                >{{ row[item.prop]?.desc }}</el-tag
              >
              <span v-else>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" width="230" fixed="right">
          <template #default="{ row }">
            <!-- <el-button type="primary" link @click="handleAdjust(row, 'edit')"
              >编辑</el-button
            > -->
            <el-button type="primary" link @click="handleAdjust(row, 'detail')"
              >详情</el-button
            >
            <!-- <el-button
              type="success"
              link
              @click="handleCheckDone(row)"
              v-if="row.status.value == '1'"
              >完成盘点</el-button
            >
            <el-button
              type="danger"
              link
              @click="handleClickDel(row.id, false)"
              :disabled="row.status.value == '1'"
              >删除</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="pages.total > 0"
        :total="pages.total"
        layout="->, prev, pager, next"
        class="mt10"
        v-model:current-page="pages.page"
        @update:current-page="getList"
      />
    </template>
  </zh-table-page>
  <!-- 新增入库 -->
  <Adjust ref="editRef" @after-save="getList" />
</template>

<style scoped></style>
